import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { LoginContext } from "../context/LoginContext";
import useSessionTimeout from "../hooks/useSessionTimeout";
import { useAdmissionDriveKind } from "../hooks/useAdmissionDriveKind";
import { DriveContext } from "../context/DriveContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: ("admin" | "student")[];
}

const DriveProtectedRoute = ({ children, requiredRoles = [] }: ProtectedRouteProps) => {
  const { isAppEdit, isDriveEdit, isDriveOpen } = useContext(DriveContext);

  // Auto-logout on inactivity (30 minutes)
  useSessionTimeout();

  if (!isDriveOpen && !isDriveEdit && !isAppEdit) {
    console.warn("Unauthorized access attempt, redirecting...");
    return <Navigate to="/applicant/home" replace />;
  }

  return <>{children}</>;
};

export default DriveProtectedRoute;
